import { SlotRepository } from '../Repositories/SlotRepository';
import { User } from '../../../User/Model/User';
import { assertAdminOrManager } from './Utils/Permission';
import { isSlotOperationRestricted, getRestrictionMessage } from './Utils/TimeRestriction';

export class BatchRefundSlotUseCase {
  constructor(private repo: SlotRepository) {}
  execute(ids: number[], current: User) {
    /* ── 시간 제한 체크 ─────────────────────────── */
    if (isSlotOperationRestricted(current)) {
      throw new Error(getRestrictionMessage('환불', current));
    }

    assertAdminOrManager(current);
    if (!ids.length) throw new Error('슬롯 ID가 없습니다.');
    return this.repo.batchRefund(ids);
  }
}